import {Injectable} from '@angular/core';

import {BehaviorSubject, Observable} from 'rxjs';
import {DIAGRAM_VERSION_STATES_ENUM} from '../../editor-interface/shared/models/diagram-version.constant';

export class NavHistoryObject {
  public id: string;
  public state: string;
  public top: string;
  public name: string;
  public description: string;
  public levelNumber: string;
  public release: string;

  constructor({diagramId: id, state, name, levelNumber, description = '', release}) {
    Object.assign(this, {id, name, levelNumber, description});
    this.state = state === DIAGRAM_VERSION_STATES_ENUM.ARCHIVE ? `r_${release.id}` : state;
  }
}

@Injectable({
  providedIn: 'root'
})
export class NavigationHistoryService {
  private navigationHistory: BehaviorSubject<NavHistoryObject[]> = new BehaviorSubject<
    NavHistoryObject[]
  >([]);
  private currentNav: NavHistoryObject;
  public navigationHistory$: Observable<NavHistoryObject[]> = this.navigationHistory.pipe();

  private isSameNav(newNavItem) {
    const currentNavItem = this.currentNav;

    if (!currentNavItem) {
      return false;
    }

    return newNavItem.id === currentNavItem.id && newNavItem.state === currentNavItem.state;
  }

  public getNavHistory() {
    return this.navigationHistory.getValue();
  }

  public addCurrentNavItem(diagramJson) {
    const pendingNav = new NavHistoryObject(diagramJson);

    if (this.currentNav && !this.isSameNav(pendingNav)) {
      this.navigationHistory.next([this.currentNav, ...this.getNavHistory()]);
    }

    this.currentNav = pendingNav;
  }

  public navSelectedItem(index) {
    const navHistory = this.getNavHistory();
    const result = navHistory[index];

    navHistory.splice(0, index + 1);
    this.navigationHistory.next(navHistory);
    this.currentNav = null;

    return result;
  }

  public navLastItem() {
    const [lastNavItem, ...allPrevNavItems] = this.getNavHistory();

    this.navigationHistory.next([...allPrevNavItems]);
    this.currentNav = null;
  }

  public lastNavItem() {
    const [lastNavItem, ...allPrevNavItems] = this.getNavHistory();

    return lastNavItem;
  }

  public getCurrent() {
    return this.currentNav;
  }
}
